import { render, staticRenderFns } from "./CardsStack.vue?vue&type=template&id=43a32c90&scoped=true&"
import script from "./CardsStack.vue?vue&type=script&lang=js&"
export * from "./CardsStack.vue?vue&type=script&lang=js&"
import style0 from "./CardsStack.vue?vue&type=style&index=0&id=43a32c90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a32c90",
  null
  
)

export default component.exports